// src/commons.ts
import { basename } from "path";
import {
  reduceAST
} from "publicodes";
import yaml from "yaml";
var IMPORT_KEYWORD = "importer!";
function consumeMsg() {
}
var disabledLogger = {
  log: consumeMsg,
  warn: consumeMsg,
  error: consumeMsg
};
function getAllRefsInNode(node) {
  return reduceAST(
    (refs, node2) => {
      if (node2 === void 0) {
        return refs;
      }
      if (node2.nodeKind === "reference" && node2.dottedName && !refs.includes(node2.dottedName)) {
        refs.push(node2.dottedName);
      }
    },
    [],
    node
  );
}
var binaryOps = ["+", "-", "*", "/", ">", "<", ">=", "<=", "=", "!="];
function mapParsedExprAST(parsedExpr, fn) {
  if ("variable" in parsedExpr || "constant" in parsedExpr) {
    return fn(parsedExpr);
  }
  if (binaryOps.some((op) => op in parsedExpr)) {
    for (const key of Object.keys(parsedExpr)) {
      return fn({
        [key]: [
          mapParsedExprAST(parsedExpr[key][0], fn),
          mapParsedExprAST(parsedExpr[key][1], fn)
        ]
      });
    }
  }
  return parsedExpr;
}
function serializeParsedExprAST(parsedExpr, needsParens = false) {
  if ("variable" in parsedExpr) {
    return parsedExpr.variable;
  }
  if ("constant" in parsedExpr) {
    return parsedExpr.constant.nodeValue + ("unit\xE9" in parsedExpr ? parsedExpr.unit\u00E9 ?? "" : "");
  }
  if (binaryOps.some((op) => op in parsedExpr)) {
    for (const key of Object.keys(parsedExpr)) {
      return (needsParens ? "(" : "") + `${serializeParsedExprAST(
        parsedExpr[key][0],
        true
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      )} ${key} ${serializeParsedExprAST(parsedExpr[key][1], true)}` + (needsParens ? ")" : "");
    }
  }
}
function substituteInParsedExpr(parsedExpr, variableName, constValue) {
  const { type, nodeValue } = !isNaN(Number(constValue)) ? { type: "number", nodeValue: Number.parseFloat(constValue) } : { type: "string", nodeValue: constValue };
  return mapParsedExprAST(parsedExpr, (node) => {
    if ("variable" in node && node?.variable === variableName) {
      return { constant: { type, nodeValue } };
    }
    return node;
  });
}
function getDoubleDefError(filePath, name, firstDef, secondDef) {
  return new Error(
    `[${basename(filePath)}] La r\xE8gle '${name}' est d\xE9j\xE0 d\xE9finie

Essaie de remplacer :

${yaml.stringify(firstDef, { indent: 2 })}

Avec :

${yaml.stringify(secondDef, { indent: 2 })}`
  );
}
function getValueWithoutQuotes(value) {
  if (typeof value !== "string" || !value.startsWith("'") || value === "oui" || value === "non") {
    return null;
  }
  return value.slice(1, -1);
}
var DEFAULT_BUILD_DIR = "publicodes-build";

export {
  IMPORT_KEYWORD,
  disabledLogger,
  getAllRefsInNode,
  mapParsedExprAST,
  serializeParsedExprAST,
  substituteInParsedExpr,
  getDoubleDefError,
  getValueWithoutQuotes,
  DEFAULT_BUILD_DIR
};
